import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-column">
                        <h4>Company</h4>
                        <Link to="/about">About Us</Link>
                        <a href="/about">Our Team</a>
                    </div>
                    <div className="footer-column">
                        <h4>Connect</h4>
                        <Link to="/contact">Contact Us</Link>
                        <a href="https://www.youtube.com/channel/UCGnMSw2orfBV5TzRSApB_Og">YouTube</a>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2025 Megh.ai. All rights reserved. | <Link to="/privacy" style={{ marginLeft: '0.5rem' }}>Privacy Policy</Link> |
                        <Link to="/terms" style={{ marginLeft: '0.5rem' }}>Terms of Service</Link></p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;